import type { ReactNode } from 'react';
import React from 'react';
import type { ContentState, DraftDecorator } from 'draft-js';
import styles from './linkDecorator.scss';

type LinkComponentProps = {
  contentState: ContentState;
  entityKey: string;
  children: ReactNode;
};

const LinkComponent: React.FC<LinkComponentProps> = ({
  contentState,
  entityKey,
  children,
}) => {
  const { url, targetNewWindow } = contentState.getEntity(entityKey).getData();

  return (
    <a
      href={url}
      className={styles.link}
      target={targetNewWindow ? '_blank' : '_self'}
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

const findLinkEntities: Extract<DraftDecorator['strategy'], Function> = (
  contentBlock,
  callback,
  contentState,
) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === 'LINK'
    );
  }, callback);
};

export const linkDecorator: DraftDecorator = {
  strategy: findLinkEntities,
  component: LinkComponent,
};
